<template>
  <div>
    <b-row class="match-height pb-1">
      <b-col cols="6">
        <h2 class="font-weight-bolder">Mã giới thiệu/Mã giảm giá</h2>
      </b-col>
      <b-col cols="2">
        <b-form-datepicker
            v-model="serverParams.columnFilters.startDate"
            :date-format-options="{
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
            }"
            locale="vi-VN"
        />
      </b-col>
      <b-col cols="2">
        <b-form-datepicker
            v-model="serverParams.columnFilters.endDate"
            :date-format-options="{
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
            }"
            locale="vi-VN"
        />
      </b-col>
      <b-col cols="2">
        <b-button class="ml-1" variant="primary" @click="exportExcel">Xuất Excel</b-button>
      </b-col>
    </b-row>
    <b-row class="pb-2">
      <b-button class="ml-1" variant="primary" @click="$router.push({name: 'DiscountCode'})">Mã giảm giá</b-button>
      <b-button class="ml-1" variant="primary" @click="$router.push({name: 'ReferralCode'})">Mã giới thiệu</b-button>
      <!-- <b-button variant="primary" @click="$router.push({name: 'ReferralCodeMGM'})" class="ml-1">Mã giới thiệu MGM</b-button> -->
    </b-row>
    <b-row class="pb-1">
      <b-col cols="6">
        <b-card class="card-congratulation-medal">
          <h5>Số lượng mã được sử dụng theo ngày</h5>
          <p class="mb-0">
            <b-link class="font-weight-bolder">{{ voucherDashboard[0].Voucher_Spent_Today }}</b-link>
            mã giảm giá được sử dụng hôm nay
          </p>
          <p>
            <b-link class="font-weight-bolder">0</b-link>
            mã giới thiệu được sử dụng hôm nay
          </p>
          <!-- chart -->
          <vue-apex-charts
              ref="statisticsOrderRef"
              :options="statisticsOrder.chartOptions"
              :series="statisticsOrder.series"
              height="350"
              type="line"
          />
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  BAvatar,
  BButton,
  BCard,
  BCardBody,
  BCardHeader,
  BCardText,
  BCardTitle,
  BCol,
  BFormDatepicker,
  BImg,
  BLink,
  BMedia,
  BMediaAside,
  BMediaBody,
  BProgress,
  BRow,
  BTab,
  BTabs,
} from "bootstrap-vue";
import VuePdfApp from "vue-pdf-app";
import "vue-pdf-app/dist/icons/main.css";
import useJwt from "@/auth/jwt/useJwt";
import Select2 from "v-select2-component";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import Ripple from "vue-ripple-directive";
import {kFormatter} from "@core/utils/filter";
import VueApexCharts from "vue-apexcharts";
import StatisticCardVertical from "@core/components/statistics-cards/StatisticCardVertical.vue";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import {PolarArea} from "vue-chartjs";
import moment from "moment";

export default {
  components: {
    BProgress,
    PolarArea,
    AppTimeline,
    AppTimelineItem,
    StatisticCardHorizontal,
    StatisticCardVertical,
    VueApexCharts,
    BMedia,
    BMediaAside,
    BAvatar,
    BMediaBody,
    BLink,
    BImg,
    BCardHeader,
    BButton,
    BCardBody,
    BCardTitle,
    kFormatter,
    BFormDatepicker,
    Ripple,
    BRow,
    BCol,
    VuePdfApp,
    Select2,
    BCard,
    flatPickr,
    BTab,
    BCardText,
    BTabs,
    FeatherIcon,
  },
  directives: {
    Ripple,
  },
  watch: {},
  data() {
    return {
      serverParams: {
        columnFilters: {
          endDate: moment(new Date()).format('YYYY-MM-DD'),
          startDate: moment(new Date()).format('YYYY-MM-DD'),
        },
        page: 1,
        pageSize: 50,
        sortBy: {},
        sort: []
      },
      statisticsOrder: {
        series: [
          {
            name: "MGG/MGT",
            data: [12, 11, 14, 18, 17, 13, 13]
          },
          {
            name: "Đơn hàng",
            data: [28, 29, 33, 36, 32, 32, 33]
          },
        ],
        chartOptions: {
          chart: {
            height: 350,
            type: 'line',
            dropShadow: {
              enabled: true,
              color: '#000',
              top: 18,
              left: 7,
              blur: 10,
              opacity: 0.2
            },
            toolbar: {
              show: false
            }
          },
          colors: ['#ED1F24', '#1FEDD4'],
          dataLabels: {
            enabled: true,
          },
          stroke: {
            curve: 'smooth'
          },
          grid: {
            borderColor: '#e7e7e7',
            row: {
              colors: ['#f3f3f3', 'transparent'],
              opacity: 0.5
            },
          },
          markers: {
            size: 1
          },
          xaxis: {
            categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
            title: {
              text: 'Month'
            }
          },
          yaxis: {
            min: 5,
            max: 100
          },
          legend: {
            position: 'bottom',
            horizontalAlign: 'left',
            floating: true,
            offsetY: 0,
            offsetX: 0
          }
        }
      },
      voucherDashboard: [],
    }
  },
  methods: {},
  mounted() {
    this.isLoading = true;
    useJwt.get('voucher/dashboard').then(res => {
      this.voucherDashboard = res.data.result[0]
      this.isLoading = false;
    }).catch(err => {
      console.log(err)
      this.isLoading = false;
    })
  },
};

</script>
<style lang="scss">
@import "@core/scss/vue/pages/dashboard-ecommerce.scss";
@import "@core/scss/vue/libs/chart-apex.scss";

.center-chart {
  display: flex;
  justify-content: center;
  padding: 20px 0;
}

.form-control {
  background-color: #FFF !important;
}
</style>
